import { render, staticRenderFns } from "./personnelContact.vue?vue&type=template&id=16cfa48c"
import script from "./personnelContact.vue?vue&type=script&lang=ts"
export * from "./personnelContact.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports